import _ from "lodash";

export const dynamicArray = (data, query) => {
  const result = _.find(data, query);
  if (!result) {
    data.push(query);
    return data;
  } else return _.pullAllWith(data, [query], _.isEqual);
};

/**
 * Join css style properties.
 *
 * The decimal deparator can be left out in each string (except when you combine multiple properties in one string), double ones will be filtered out.
 *
 * @param { ...any } props Css properties, each as a separate string or combined as one string
 * @example styles(`margin-left: ${ marginLeft || 3 }rem, 'font-weight: bold; font-family: Roboto;')
 * @returns string
 */

export const styles = (...props) => {
  return props
    .filter((p) => p)
    .join("; ")
    .replace(/;+/g, ";");
};

export const seconds = (amount) => amount * 1000;
export const minutes = (amount) => seconds(60) * amount;
